import React from 'react';
import { AwardIcon, CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { productBrand, productEdition, totalBonuses, totalVolumes } from '../data/offer';
export function SystemSection() {
  return <section className="border-y border-steel/40 bg-navy-900 py-16 sm:py-20" aria-labelledby="system-title" data-id="element-189" data-mp="3bhbu9hm7k3fw">
      <div className="mx-auto max-w-4xl px-4 text-center" data-id="element-190" data-mp="36jk00gy3c58j">
        <span className="inline-flex items-center gap-2 rounded-full border border-gold/50 bg-navy-950/40 px-4 py-2 text-xs font-extrabold uppercase tracking-[.12em] text-white" data-id="element-191" data-mp="31kz58x1lydrh">
          <AwardIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-192" data-mp="2srvs6puvk2xd" /> The Most Complete Power Distribution & Switchgear Professional System
        </span>
        <SectionHeading id="system-title" className="mt-6" data-id="element-193" data-mp="2nr7szgwhsfs2">
          {productBrand} — <span className="text-gold" data-id="element-194" data-mp="2itpsmewjj8vo">{productEdition}</span>
        </SectionHeading>
        <p className="mt-4 font-semibold text-steel-light" data-id="element-195" data-mp="2dwft26fftgu4">
          {totalVolumes} volumes · {totalBonuses} exclusive bonuses
        </p>

        <p className="mx-auto mt-10 flex max-w-3xl items-start gap-3 rounded-2xl border border-steel bg-navy-950 p-6 text-left text-lg font-semibold leading-relaxed text-white shadow-lg shadow-black/40" data-id="element-196" data-mp="13xdclv57aulu">
          <CheckIcon className="mt-1 h-6 w-6 shrink-0 text-copper" aria-hidden="true" data-id="element-197" data-mp="tz7e7nils6lq" />
          A complete technical system to understand how power is distributed: how single-line diagrams describe the
          system, how LV switchboards and MV switchgear are built and operated, how protection devices clear faults, and
          how professionals test, maintain and work on distribution equipment safely.
        </p>
      </div>
    </section>;
}